import React, { useState, useEffect } from "react";
import { Container, Form, Button, Carousel } from "react-bootstrap";
const SearchBanner = () => {
  const [index, setIndex] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");

  const handleSelect = (selectedIndex: number) => {
    setIndex(selectedIndex);
  };

  const handleSearch = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
  };

  const imgs = ['/img/home-slide1.png', '/img/home-slide2.png', '/img/home-slide3.png', '/img/home-slide4.png'];

  return (
    <div className="search-banner position-relative" style={{ marginTop: '100px' }}>
      {/* <Carousel
        activeIndex={index}
        onSelect={handleSelect}
        controls={false}
        indicators={false}
      >
        {imgs.map((image, idx) => (
          <Carousel.Item key={idx}>
            <img
              className="d-block w-100"
              src={image}
              alt={`Slide ${idx + 1}`}
              style={{ height: "200px", objectFit: "cover" }}
            />
          </Carousel.Item>
        ))}
      </Carousel> */}
    </div>
  );
};

export default SearchBanner;
